export const AppAuthenticationHeader = {
    "ho-app-auth": "HolterOnline=51fb74e5-d12e-4943-8470-481577f74b7c",
};
